import { MenuButton } from '@szhsin/react-menu';
import styled from 'styled-components';

export const MenuBtn = styled(MenuButton)`
  background: var(--white);
  border: 0.0625rem solid var(--tertiary-dark); /* 1px */
  border-radius: 0.2rem;
  padding: 0.5rem;
`;
